import React, { Component } from 'react';
import Cursor from '../../../../../../../../../../../css/ppt-editor-cursor-global.less';
import _get from 'lodash/get';
import * as Graphic from '../../../../../../../../../../../slide/infrastructure/module/independent/graphic';
import { bgLineOfType } from '../../../../../../../../../../../slide/infrastructure/module/dependent/line-info';
import { ServicesContext } from '../../../context';
import { IElementModelStyle } from '@src/slide/domain/ui-model/element-modeles/Interface/model-props/element-model-props.interface';

export interface GraphicLineEditorProps {
    model: Omit<IElementModelStyle, 'left' | 'right' | 'top'> & { controlValues: number[] | undefined };
    scale: number;
    onControlValueChange: (...any: any) => any;
    onControlPointMoving: (...any: any) => any;
}

export default class GraphicLineEditor<P extends GraphicLineEditorProps> extends Component<P> {
    public static contextType = ServicesContext;
    protected startPos;
    protected changeControlPointIndex;
    protected controlPoints;
    protected leftInClient;
    protected topInClient;
    protected lineInfo;
    public constructor(props, context) {
        super(props, context);
        this.initLineInfo(props);
    }

    public render() {
        return (
            <React.Fragment>
                {
                    this.renderControlPoints(this.props.model.width, this.props.model.height)
                }
            </React.Fragment>
        );
    }

    public componentWillUnmount = () => {
        if (this.lineInfo) {
            this.lineInfo = null;
        }
    };


    // eslint-disable-next-line camelcase
    public UNSAFE_componentWillReceiveProps(nextProps) {
        this.initLineInfo(nextProps);
    }

    protected renderControlPoints = (w, h) => {
        this.controlPoints = this.lineInfo.getControlPoints(w, h);
        return this.controlPoints.map(this.renderControlPoint);
    };

    protected getRelativePosByEvent = (e) => {
        const relativePos = this.getEventCoordinates(e); // 绝对坐标
        relativePos.x = relativePos.x / this.props.scale;
        relativePos.y = relativePos.y / this.props.scale;
        return relativePos;
    };

    protected handleControlPointMouseDown = (index, e) => {
        e.stopPropagation();
        e.preventDefault();
        this.startPos = this.getRelativePosByEvent(e);// 真实坐标相对于PPT比例
        this.changeControlPointIndex = index;
        let controlPoint = this.controlPoints[index];
        // 点中的点相的真实坐标，只不过是相对于矩形框的左上角
        if (this.props?.model?.flipH === 1) {
            controlPoint = Graphic.afterFlipH(controlPoint, this.props.model.width / 2);
        }
        if (this.props?.model?.flipV === 1) {
            controlPoint = Graphic.afterFlipV(controlPoint, this.props.model.height / 2);
        }
        if (this.props?.model?.rotate) {
            const centerX = this.props.model.width / 2;
            const centerY = this.props.model.height / 2;
            controlPoint = Graphic.afterRotate(controlPoint, this.props.model.rotate, centerX, centerY);
        }
        this.leftInClient = this.startPos.x - controlPoint.x;
        this.topInClient = this.startPos.y - controlPoint.y;
        document.addEventListener('mousemove', this.handleControlPointMouseMove);
        document.addEventListener('mouseup', this.handleControlPointChangeEnd);
        document.addEventListener('touchmove', this.handleControlPointMouseMove, { passive: false });
        document.addEventListener('touchend', this.handleControlPointChangeEnd, { passive: false });
    };

    protected handleControlPointMouseMove = (e) => {
        e.stopPropagation();
        e.preventDefault();
        let currentEventPos = this.getRelativePosByEvent(e);
        const centerX = this.leftInClient + (this.props.model.width / 2);
        const centerY = this.topInClient + (this.props.model.height / 2);
        if (this.props?.model?.rotate) {
            currentEventPos = Graphic.afterRotate(currentEventPos, 360 - this.props.model.rotate, centerX, centerY);
        }
        if (this.props?.model?.flipH === 1) {
            currentEventPos = Graphic.afterFlipH(currentEventPos, centerX);
        }
        if (this.props?.model?.flipV === 1) {
            currentEventPos = Graphic.afterFlipV(currentEventPos, centerY);
        }
        const currentPosWithRect = {
            x: currentEventPos.x - this.leftInClient,
            y: currentEventPos.y - this.topInClient,
        };
        this.lineInfo.controlValues = this.lineInfo.controlValuesWithControlPointChange(
            this.changeControlPointIndex,
            this.lineInfo.controlValues,
            currentPosWithRect,
            this.props.model.width,
            this.props.model.height,
        );
        if (this.props.onControlPointMoving) {
            this.props.onControlPointMoving(this.lineInfo.controlValues);
        }
    };

    protected handleControlPointChangeEnd = (e) => {
        e.stopPropagation();
        e.preventDefault();
        document.removeEventListener('mousemove', this.handleControlPointMouseMove);
        document.removeEventListener('mouseup', this.handleControlPointChangeEnd);
        document.removeEventListener('touchmove', this.handleControlPointMouseMove);
        document.removeEventListener('touchend', this.handleControlPointChangeEnd);
        if (this.props.onControlValueChange) {
            this.props.onControlValueChange(this.lineInfo.controlValues);
        }
    };

    protected renderControlPoint = (point, index) => {
        const l = 10 / this.props.scale;
        const { scale } = this.props;
        const path = `M${l / 2} ${0} L${l} ${l / 2} L${l / 2} ${l} L${0} ${l / 2} Z`;
        return (
            <svg
                key={index}
                xmlns="http://www.w3.org/2000/svg"
                version="1.1"
                style={{
                    width: l,
                    height: l,
                    left: point.x - (l / 2),
                    top: point.y - (l / 2),
                    position: 'absolute',
                    zIndex: 1000,
                }}
                filter={`drop-shadow(0 ${1 / scale} ${3 / scale} rgba(0,0,0,0.32))`}
            >
                <path
                    stroke={'#FFFFFF'}
                    strokeWidth={1 / scale}
                    fill={'#F5A623'}
                    d={path}
                    onMouseDown={this.handleControlPointMouseDown.bind(this, index)}
                    pointerEvents={'auto'}
                    className={Cursor['nwse-resize']}
                >
                </path>
            </svg>
        );
    };

    private initLineInfo(props) {
        const Class = bgLineOfType(_get(props.model, 'bgLine'));
        if (Class) {
            this.lineInfo = new Class();
        }
        this.setControlValues(props.model.controlValues);
    }

    private setControlValues(controlValues) {
        if (controlValues && controlValues.length > 0) {
            this.lineInfo.controlValues = controlValues.slice();
        } else if (!controlValues) {
            this.lineInfo.controlValues = this.lineInfo.defaultValue.controlValues.slice();
        }
    }

    private getEventCoordinates = e => ({
        x: e.touches ? e.touches[0].clientX : e.clientX,
        y: e.touches ? e.touches[0].clientY : e.clientY,
    });
}
